import { render, staticRenderFns } from "./ConferenceDetailPage.vue?vue&type=template&id=5c94035a"
import script from "./ConferenceDetailPage.vue?vue&type=script&lang=js"
export * from "./ConferenceDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports